import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import { AngularFireStorageReference, AngularFireStorage } from '@angular/fire/storage';
import * as firebase from 'firebase/app'

import { User } from 'shared-stuff'

import { auditLogService } from '../services/auditLog.service'
import { AuthService } from './auth.service';

@Injectable()
export class UploadService {

  constructor(
    private db: AngularFirestore,
    private storage: AngularFireStorage,
    private auditLog: auditLogService
  ) { }

  // deletes a document and its associated upload
  private async deleteUpload(docId: string) {
    const docRef = this.db.collection('uploads').doc(docId)
    const snap = await docRef.get().toPromise()
    const path = snap.data().path
    const storageRef = this.storage.ref(path)

    docRef.delete()
    storageRef.delete()
  }

  // deletes an education document, its associated upload, and updates user's doc
  public async deleteAlgebra(docId: string, currentUserRef: AngularFirestoreDocument<User>) {
    currentUserRef.update({
      algebraFiles: firebase.firestore.FieldValue.arrayRemove(docId)
    })

    this.deleteUpload(docId).then( 
      success => {
        this.auditLog.addRecord("algebra","delete",docId)
    }, 
      failure => {
        console.log("Failed to delete algebra upload")
    })
  }

  // deletes an education document, its associated upload, and updates user's doc
  public async deleteEducation(docId: string, currentUserRef: AngularFirestoreDocument<User>) {
    currentUserRef.update({
      educationFiles: firebase.firestore.FieldValue.arrayRemove(docId)
    })

    this.deleteUpload(docId).then( 
      success => {
        this.auditLog.addRecord("education","delete",docId)
    }, 
      failure => {
        console.log("Failed to delete education upload")
    })
  }


  // deletes a license document, its associated upload, and updates user's doc
  public async deleteLicense(docId: string, currentUserRef: AngularFirestoreDocument<User>) {
    currentUserRef.update({
      licenseFiles: firebase.firestore.FieldValue.arrayRemove(docId)
    })

    this.deleteUpload(docId).then( 
      success => {
        this.auditLog.addRecord("license","delete",docId)
    }, 
      failure => {
        console.log("Failed to delete license upload")
    })
  }

  // deletes a testing document, its associated upload, and updates user's doc
  public async deleteTesting(docId: string, currentUserRef: AngularFirestoreDocument<User>) {
    currentUserRef.update({
      testingFiles: firebase.firestore.FieldValue.arrayRemove(docId)
    })

    this.deleteUpload(docId).then( 
      success => {
        this.auditLog.addRecord("testing","delete",docId)
    }, 
      failure => {
        console.log("Failed to delete testing upload")
    })
  }

}


// WEBPACK FOOTER //
// /Users/elliot/code/abc-angular/src/app/core/upload.service.ts